import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

const InjectMassage = (props) => <FormattedMessage {...props} />;

export const formatMessage = (intl, id = '', params = {}) => {
  let defaultMessage = id || 'default';
  const indexOfDotPoint = defaultMessage.lastIndexOf('.');
  defaultMessage = defaultMessage.substr(indexOfDotPoint + 1);
  return intl.formatMessage({ id, defaultMessage }, params);
};

export default injectIntl(InjectMassage, {
  withRef: false,
});
